import { render, staticRenderFns } from "./FileUploadConfig.vue?vue&type=template&id=44093b5b&scoped=true"
import script from "./FileUploadConfig.vue?vue&type=script&lang=js"
export * from "./FileUploadConfig.vue?vue&type=script&lang=js"
import style0 from "./FileUploadConfig.vue?vue&type=style&index=0&id=44093b5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44093b5b",
  null
  
)

export default component.exports